import Rpc from "@/Rpc";
import MD5 from "crypto-js/md5";

class _AppTranslations{
    constructor() {
        this.langs = [];
        this.langsNames = {};
        this.selectedLang = "en";

        this.urlLang = null;

        this.translations = {};
    }

    checkUrlForLanguage(){
        const url = new URLSearchParams(location.search)

        if(url.has("lang")){
            this.urlLang = url.get("lang").toLowerCase();
        }

    }
    async setup(){
        this.langs = await Rpc.AppTranslations.languages();
        this.langsNames = await Rpc.AppTranslations.languageNamesNative();
        this.langNamesInInterfaceLanguage = await Rpc.AppTranslations.languageNamesInSessionLanguage();

        this.langs.sort();

        if(!this.langs.includes(this.urlLang)){
            this.urlLang = null;
        }

        let storedLang = null;
        storedLang = localStorage.getItem("app-language");
        if(!this.langs.includes(storedLang)){
            storedLang = null;
        }

        if(this.urlLang){
            this.selectedLang = this.urlLang;
        } else if(storedLang){
            this.selectedLang = storedLang;
        } else {
            this.selectedLang = "en";
        }
        localStorage.setItem("app-language", this.selectedLang);

        this.translations = await Rpc.AppTranslations.selectLanguage(this.selectedLang);
    }

    switchLang(lang){
        let url = window.location.href;
        if (url.indexOf('?') > -1){
            url += `&lang=${lang}`
        } else {
            url += `?lang=${lang}`
        }
        localStorage.setItem("app-language", lang);
        window.location.href = url;
    }
    trimKey(key){
        if(key.length >= 128){
            let digest = MD5(key).toString();
            key = key.substring(0, 32) + "_" + digest + "_" + key.substring(key.length - 16);
        }
        return key;
    }

    /**
     *
     * @param key {String}
     * @param defaultPhrase {String}
     * @param args {...}
     */
    translate(key, defaultPhrase, args=undefined){

        let base = defaultPhrase;
        key = this.trimKey(key);
        if(this.translations.hasOwnProperty(key)){
            base = this.translations[key];
        } else{
            console.warn("Translation not found for key:" + key)
        }

        if(arguments.length >= 2){
            for(let i = 2; i< arguments.length; i++){
                base = base.replace("#{" + (i-1) + "}", arguments[i]);
                base = base.replace("${" + (i-1) + "}", arguments[i]);
            }
        }
        return base;
    }

    /**
     *
     * @param key {String}
     * @param defaultPhrase {String}
     * @param args {...}
     */
    translateUnchecked(key, defaultPhrase, args=undefined){
        let base = defaultPhrase;
        key = this.trimKey(key);

        if(this.translations.hasOwnProperty(key)){
            base = this.translations[key];
        }
        return base;
    }
}

const AppTranslations = new _AppTranslations();

export default AppTranslations;
if(window){
    window["AppTranslations"] = AppTranslations;
}
